import React from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import CheckBox from '@node-space/storybook-components/dist/CheckBox'
import { ErrorText } from '@node-space/storybook-components/dist/FormElements'
import { InputProps } from '@node-space/storybook-components/dist/Input'
import Radio from '@node-space/storybook-components/dist/Radio'
import { Box, Text } from '@node-space/ui-components'
import { InputLabelTooltip } from 'components/Text/InputLabelTooltip'
import { ConfirmRadioValues } from 'constants/Forms'
import { FormFieldsType } from 'types/formField'
import { ControllerInfoKeyList, FirstControllerInfoKey } from './helpers/constants'
import { AccountContactFormData, ControllerFormKey } from './helpers/types'

export interface ControllerFieldsProps {
  formFields: FormFieldsType<ControllerFormKey>
  formErrors: FieldErrors<AccountContactFormData>
}

export const ControllerFields = ({ formFields, formErrors }: ControllerFieldsProps) => {
  const { t } = useTranslation()

  const showControllerInfoFields =
    (formFields?.isController as InputProps)?.value === ConfirmRadioValues.YES

  const controllerInfoError = formErrors?.[FirstControllerInfoKey]

  return (
    <>
      <Box>
        <InputLabelTooltip
          id={formFields?.isController?.name}
          labelText={formFields?.isController?.label}
          tooltipHeader={t('controller.tooltip.heading')}
          tooltipText={
            <Box flexCol gap={4}>
              <Text color="inherit">{t('controller.tooltip.condition')}</Text>
              <Text color="inherit">{t('controller.tooltip.description')}</Text>
            </Box>
          }
        />
        <Radio {...formFields?.isController} borderless={false} horizontal label="" />
      </Box>
      {showControllerInfoFields && (
        <Box flexCol gap={16}>
          {ControllerInfoKeyList?.map(key => <CheckBox key={key} {...formFields?.[key]} />)}
          {!!controllerInfoError && <ErrorText text={controllerInfoError?.message} />}
        </Box>
      )}
    </>
  )
}
